import { useEffect, useState } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography } from '@mui/material';
// components
import axios from 'axios';
import Page from '../components/Page';
import Iconify from '../components/Iconify';
// sections
import { AppWidgetSummary, CalendarPage } from '../sections/@dashboard/app';

// ----------------------------------------------------------------------

export default function DashboardApp() {
  const theme = useTheme();
  const [stats, setStats] = useState({});
  
  // Get the current year and month
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // Months are 0-indexed

  // Fetch statistics from the backend
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`https://cpccbe.org/api/calender/get-event/stats?year=${currentYear}&month=${currentMonth}`);
        setStats(response.data);
      } catch (error) {
        console.error("Error fetching statistics:", error);
      }
    };

    fetchStats();
  }, [currentYear, currentMonth]); // Dependency array ensures it updates when the month changes

  return (
    <Page title="Dashboard">
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Dashboard
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <AppWidgetSummary
              title="Total Events  This Month"
              total={stats.totalEvents || 0} // Adjusted to match API response
              color="info"
              icon={'teenyicons:adjust-vertical-solid'}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AppWidgetSummary
              title="Upcoming Events This Month"
              total={stats.upcomingEvents || 0}
              color="success"
              icon={'teenyicons:bag-alt-solid'}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AppWidgetSummary
              title="Events Completed This Month"
              total={stats.pastEvents || 0}
              color="warning"
              icon={'teenyicons:adjust-horizontal-solid'}
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <CalendarPage />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
